<div class="search-business-dialog">
  <div mat-dialog-title>
    <h2>Select Business</h2>
  </div>

  <div mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Select a business</mat-label>
      <mat-select [formControl]="businessControl" placeholder="Choose a business">
        @for (business of businesses; track business) {
        <mat-option [value]="business">
          {{ business.businessname }} (ID: {{ business.businessid }})
        </mat-option>
        }
      </mat-select>
      @if (searchingBusinesses) {
      <mat-spinner matSuffix diameter="25"></mat-spinner>
      }
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!businessControl.value"
      (click)="confirm()"
    >
      Confirm
    </button>
  </div>
</div>
